import { IconsProps } from '@/types/shared'
import React from 'react'

const CustomerMktIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_672_1546)">
                    <path
                        d="M20 4.5H4C2.9 4.5 2 5.4 2 6.5V18.5C2 19.6 2.9 20.5 4 20.5H20C21.1 20.5 22 19.6 22 18.5V6.5C22 5.4 21.1 4.5 20 4.5ZM20 18.5H4V6.5H20V18.5ZM4 0.5H20V2.5H4V0.5ZM4 22.5H20V24.5H4V22.5ZM12 12.5C13.38 12.5 14.5 11.38 14.5 10C14.5 8.62 13.38 7.5 12 7.5C10.62 7.5 9.5 8.62 9.5 10C9.5 11.38 10.62 12.5 12 12.5ZM12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9ZM17 16.49C17 14.4 13.69 13.5 12 13.5C10.31 13.5 7 14.4 7 16.49V17.5H17V16.49ZM8.81 16C9.42 15.48 10.84 15 12 15C13.17 15 14.59 15.48 15.2 16H8.81Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_672_1546">
                        <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0 0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}

export default CustomerMktIcons
